export const defaultMapZoom = 12;
